export class ApiConstants {
	public static API_SERVER = '';
	public static URL_BASE: string;
	public static URL_AUTH: string;
	public static URL_USERS: string;
	public static URL_ROLES: string;
	public static URL_MAJORS: string;
	public static URL_SUBJECTS: string;
	public static URL_CLASSES: string;
	public static URL_WEEKS: string;
	public static URL_SCHOOL_SETTINGS: string;
	public static URL_ANNOUNCEMENTS: string;
	public static URL_WEEKLY_PLANS: string;
	public static URL_STUDENTS: string;
	public static URL_PARENTS: string;
	public static URL_BUSES: string;
	public static URL_NATIONALITIES: string;
	public static URL_RELIGIONS: string;
	public static URL_ACADEMIC_YEARS: string;
	public static URL_LOCATIONS: string;
	public static URL_ATTENDANCE: string;
	public static URL_PICKUP: string;

	static setData(address: string) {
		ApiConstants.API_SERVER = address;
		ApiConstants.URL_BASE = `${ApiConstants.API_SERVER}/api/v1/wp`;
		ApiConstants.URL_AUTH = `${ApiConstants.URL_BASE}/auth`;
		ApiConstants.URL_USERS = `${ApiConstants.URL_BASE}/users`;
		ApiConstants.URL_ROLES = `${ApiConstants.URL_USERS}/roles`;
		ApiConstants.URL_MAJORS = `${ApiConstants.URL_BASE}/majors`;
		ApiConstants.URL_SUBJECTS = `${ApiConstants.URL_BASE}/subjects`;
		ApiConstants.URL_CLASSES = `${ApiConstants.URL_BASE}/classes`;
		ApiConstants.URL_WEEKS = `${ApiConstants.URL_BASE}/weeks`;
		ApiConstants.URL_SCHOOL_SETTINGS = `${ApiConstants.URL_BASE}/school-settings`;
		ApiConstants.URL_ANNOUNCEMENTS = `${ApiConstants.URL_BASE}/announcements`;
		ApiConstants.URL_WEEKLY_PLANS = `${ApiConstants.URL_BASE}/weekly-plans`;
		ApiConstants.URL_STUDENTS = `${ApiConstants.URL_BASE}/students`;
		ApiConstants.URL_PARENTS = `${ApiConstants.URL_BASE}/parents`;
		ApiConstants.URL_BUSES = `${ApiConstants.URL_BASE}/buses`;
		ApiConstants.URL_NATIONALITIES = `${ApiConstants.URL_BASE}/nationalities`;
		ApiConstants.URL_RELIGIONS = `${ApiConstants.URL_BASE}/religions`;
		ApiConstants.URL_ACADEMIC_YEARS = `${ApiConstants.URL_BASE}/academic-years`;
		ApiConstants.URL_LOCATIONS = `${ApiConstants.URL_BASE}/locations`;
		ApiConstants.URL_ATTENDANCE = `${ApiConstants.URL_BASE}/attendance`;
		ApiConstants.URL_PICKUP = `${ApiConstants.URL_BASE}/pickup`;
	}
}
